import { render } from "./MBaseModal.vue?vue&type=template&id=1492dd44&scoped=true"
import script from "./MBaseModal.vue?vue&type=script&lang=ts"
export * from "./MBaseModal.vue?vue&type=script&lang=ts"

import "./MBaseModal.vue?vue&type=style&index=0&id=1492dd44&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1492dd44"

export default script